import { render } from "./JapanMap.vue?vue&type=template&id=8a2820b2"
import script from "./JapanMap.vue?vue&type=script&lang=js"
export * from "./JapanMap.vue?vue&type=script&lang=js"

import "./JapanMap.vue?vue&type=style&index=0&id=8a2820b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__